export default {
	getInboxResponsibles: (state) => state.responsible,
	getInboxSchoolMembers: (state) => state.schoolMembers,
	getReceivedMessageList: (state) => state.messages.received,
	getSentMessageList: (state) => state.messages.sent,
	getInboxHeighlights: (state) => state.inboxAgenda,
	messageGroup: (state) => state.messageGroup,
	inboxSentFilter: (state) => state.filter.sent,
	inboxReceivedFilter: (state) => state.filter.received
};



// WEBPACK FOOTER //
// ./sources/app/inbox/getters.js